'use client';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import Link from '@eliadmin/core/src/components/link';
import { RiSettings3Fill } from 'react-icons/ri';

export function CustomHomepage2() {
  const { t } = useTranslations();

  return (
    <>
      <section
        className="
          cta-banner
          relative z-10
          mt-0
          flex
          w-full
          items-center
          justify-center
          px-11 py-16
          sm:px-4
          sm:py-52
      "
      >
        <div
          className="
            flex
            w-full
            max-w-[1100px]
            flex-col items-center
            justify-between
            gap-24
            sm:flex-row sm:gap-6
        "
        >
          <div>
            <h2 className="mb-4 text-xl font-bold text-secondary md:text-3xl">{t('text1145')}</h2>
            <p
              className="
                text-base
                font-extralight leading-[1.75em]
                text-white
                sm:max-w-[320px] md:max-w-[460px]
                md:text-2xl
            "
            >
              {t('text1144')}
            </p>
          </div>
          <Button
            asChild
            className="
              flex
              h-16
              items-center
              justify-center
              gap-x-2
              rounded-full
              bg-[#E5001D]
              px-8
              py-6
              text-2xl
              font-medium
              text-white
          "
          >
            <Link href={'#'} prefetch={false}>
              <RiSettings3Fill size={24} /> {t('text818')}
            </Link>
          </Button>
        </div>
      </section>
    </>
  );
}
